// Token metadata
export const TOKEN_METADATA = {
  veUSD: {
    name: 'VaultEdge USD',
    symbol: 'veUSD',
    decimals: 18,
  },
} as const

// Contract names for typechain
export const CONTRACT_NAMES = {
  VaultedgeController: 'VaultedgeController',
  VeUSDToken: 'VeUSDToken_CrossChain',
  VaultManager: 'IVaultManagerDiamond',
  BorrowerOperations: 'BorrowerOperations',
  ActivePool: 'ActivePool',
  DefaultPool: 'DefaultPool',
  StabilityPool: 'StabilityPool',
  CollSurplusPool: 'CollSurplusPool',
  SortedVaults: 'SortedVaults',
  HintHelpers: 'HintHelpers',
  DebtCapManager: 'DebtCapManager',
  DebtCapLens: 'DebtCapLens',
} as const 